var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home-wrapper"},[_c('Header',{attrs:{"currentStep":_vm.currentStep}}),_c('Main',{on:{"currentStep":function($event){_vm.currentStep = $event}}}),_c('Specialties'),_c('Partners'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }